var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_4760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 6.9998L8.6998 2.6998C8.24818 2.25036 7.63695 1.99805 6.9998 1.99805C6.36265 1.99805 5.75143 2.25036 5.2998 2.6998L2.6998 5.2998C2.25036 5.75143 1.99805 6.36265 1.99805 6.9998C1.99805 7.63695 2.25036 8.24818 2.6998 8.6998L6.9998 12.9998M7.9998 5.9998L9.9998 3.9998M17.9998 15.9998L19.9998 13.9998M16.9998 10.9998L21.2998 15.2998C22.2398 16.2398 22.2398 17.7598 21.2998 18.6998L18.6998 21.2998C17.7598 22.2398 16.2398 22.2398 15.2998 21.2998L10.9998 16.9998M14.9998 4.9998L18.9998 8.9998M21.1738 6.8118C21.7025 6.28323 21.9996 5.56627 21.9997 4.81866C21.9998 4.07104 21.7029 3.35401 21.1743 2.8253C20.6457 2.29659 19.9288 1.99951 19.1812 1.99942C18.4335 1.99933 17.7165 2.29623 17.1878 2.8248L3.8418 16.1738C3.60962 16.4053 3.43792 16.6903 3.3418 17.0038L2.0208 21.3558C1.99496 21.4423 1.99301 21.5342 2.01515 21.6217C2.0373 21.7092 2.08272 21.789 2.1466 21.8528C2.21047 21.9166 2.29042 21.9619 2.37796 21.9839C2.4655 22.0059 2.55736 22.0038 2.6438 21.9778L6.9968 20.6578C7.30997 20.5626 7.59498 20.3919 7.8268 20.1608L21.1738 6.8118Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_4760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilRuler);
export default __webpack_public_path__ + "static/media/pencil-ruler.58cea20773171fc6361f7b739e2e1d2f.svg";
export { ForwardRef as ReactComponent };